"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.hiddenCss = void 0;

var _tslib = require("tslib");

var _themeUi = require("theme-ui");

/** @jsx jsx */
var hiddenCss = "\n  position: absolute !important;\n  clip: rect(1px,1px,1px,1px) !important;\n  height: 1px !important;\n  width: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  margin: 0 !important;\n";
exports.hiddenCss = hiddenCss;

var VisuallyHidden = function VisuallyHidden(props) {
  return (0, _themeUi.jsx)("span", (0, _tslib.__assign)({}, props, {
    style: {
      position: 'absolute',
      clip: 'rect(1px,1px,1px,1px) !important',
      height: '1px !important',
      width: '1px !important',
      overflow: 'hidden !important',
      padding: '0 !important',
      margin: '0 !important'
    }
  }));
};

var _default = VisuallyHidden;
exports.default = _default;